import {
  GetHistoryCrypto,
  GetHistoryCryptoForm,
  GetHistoryCryptoList,
  GetHistoryFiat,
  GetHistoryFiatForm,
  GetHistoryFiatList,
  GetMarginWalletInfo,
  GetMarginWalletList,
  GetPortfolioChart,
  GetSpotTransferHistoryForm,
  GetSpotTransferHistoryList,
  GetSpotWalletInfo,
  GetSpotWalletList,
} from "./api";

import http from "config/http";

const walletApi = {
  getSpotWalletInfo: async () => await http.get(GetSpotWalletInfo),

  getSpotTransferHistoryForm: async () => await http.get(GetSpotTransferHistoryForm),

  getPortfolioChart: async ({ walletTypeId }) =>
    await http.get(GetPortfolioChart({ walletTypeId })),

  getSpotWalletList: async ({ isShowMore }) =>
    await http.get(GetSpotWalletList({ isShowMore })),

  getMarginWalletInfo: async () => await http.get(GetMarginWalletInfo),

  getMarginWalletList: async ({ isShowMore }) =>
    await http.get(GetMarginWalletList({ isShowMore })),

  getHistoryCryptoForm: async () => await http.get(GetHistoryCryptoForm),

  getHistoryFiatForm: async () => await http.get(GetHistoryFiatForm),

  getHistoryFiatList: async ({
    typeId,
    coinId,
    startDate,
    endDate,
    sideId,
    stateId,
    pageNumber,
    pageSize,
  }) =>
    await http.get(
      GetHistoryFiatList({
        typeId,
        coinId,
        startDate,
        endDate,
        sideId,
        stateId,
        pageNumber,
        pageSize,
      })
    ),

  getHistoryCryptoList: async ({
    coinId,
    startDate,
    endDate,
    sideId,
    pageNumber,
    pageSize,
  }) =>
    await http.get(
      GetHistoryCryptoList({
        coinId,
        startDate,
        endDate,
        sideId,
        pageNumber,
        pageSize,
      })
    ),

  getHistoryFiat: async (id) => await http.get(GetHistoryFiat(id)),

  getHistoryCrypto: async (id) => await http.get(GetHistoryCrypto(id)),

  getSpotTransferHistoryList: async ({
    coinId,
    typeTransferId,
    startDate,
    endDate,
    pageNumber,
    pageSize,
  }) =>
    await http.get(
      GetSpotTransferHistoryList({
        coinId,
        typeTransferId,
        startDate,
        endDate,
        pageNumber,
        pageSize,
      })
    ),

};

export default walletApi;
